import { Component, OnInit } from '@angular/core';
import { AzureAuthService } from 'src/service/azure-auth.service';

@Component({
  selector: 'camerawatchlayout',
  templateUrl: 'cameraWatchLayout.template.html',
})
export class CameraWatchLayoutComponent implements OnInit {

  constructor(
    public azureAuthService: AzureAuthService
  ) {}

  ngOnInit() {
    this.azureAuthService.onInit();

    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-small');
  }
}
